export default __webpack_public_path__ + "static/media/payment-ec.9ca403f4.svg";